import { Col, Container, Row } from "reactstrap";
import Breadcrumbs from "../../common-elements/breadcrumbs/Breadcrumbs";
import { useTranslation } from "react-i18next";
import AddonCard from "./AddonCard";

function AddonSection() {
  const { t } = useTranslation();
  return (
    <Container fluid>
      <Breadcrumbs mainTitle={t("Add-On")} />
      <Row>
        <Col sm="12">
          <AddonCard />
          {/* <SimplePricingCard /> */}
        </Col>
      </Row>
    </Container>
  );
}

export default AddonSection;
